
<template>
    <div class="yuji-news" :class="device == 'mobile' ? 'yuji-news-mobile' : ''">
        <div class="news padding-top">
            <div class="main">
                <div class="tags">
                    <a href="/index">首页</a>
                    >
                    <a href="/news">新闻中心</a>
                    >
                    <span>新闻详情</span>
                </div>
                <div class="news-box">
                    <h2 class="title">数字人公司羽迹科技：引领AI虚拟人软件创新</h2>
                    <div class="time">2023-06-21 10:00:10</div>
                    <div class="start">
                        随着人工智能技术的迅猛发展，虚拟人软件成为数字化时代中备受瞩目的创新应用。而在这一领域中，深圳羽迹科技有限公司以其卓越的技术实力和创新能力，成为引领AI虚拟人软件创新的领军企业。
                    </div>
                    <div class="banner">
                        <img src="@/assets/imgs/news/205.png" alt="数字人公司羽迹科技：引领AI虚拟人软件创新" srcset />
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            羽迹科技是一家专注于人工智能和图形图像算法研发的科技企业，致力于高仿真3D数字人设计、生成以及AI交互等技术的研发和应用。作为数字人领域的先驱者，羽迹科技以其自主研发的算法和技术优势，推动着AI虚拟人软件的创新与突破。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            羽迹科技的AI虚拟人软件在多个领域展现了强大的应用潜力。在医美行业，该软件可以通过单张或多张照片快速生成高保真的3D数字人脸重建，为医美专业人士提供术前仿真和效果展示的工具，实现个性化的美容方案。此外，在美妆领域，羽迹科技的软件可以帮助用户在线上试妆，实时展示不同妆容的效果，让用户更准确地选择适合自己的妆容风格。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            羽迹科技的AI虚拟人软件也在元宇宙、试穿和发型设计等领域得到广泛应用。在元宇宙中，用户可以通过虚拟人形象与数字世界进行互动，创造出属于自己的个性化体验。虚拟试穿和发型设计领域，羽迹科技的软件为用户提供了全新的虚拟体验，让用户可以在虚拟环境中尝试不同款式的服装和发型，快速找到最适合自己的选择。
                        </div>
                    </div>
                    <div class="list">
                        <div class="list-t"></div>
                        <div class="list-text">
                            羽迹科技以其领先的技术和创新的解决方案，为企业和用户带来了诸多便利和创新体验。该公司致力于为不同领域企业提供简单、高效、低成本的数字人技术服务，包括算法、云计算、软件开发和授权等。羽迹科技的软件不仅具备高保真、高效率和跨平台等优势，而且还提供全套的数字人服务，满足各行业的需求和应用场景。
                        </div>
                    </div>


                    <div class="end">
                        数字人公司羽迹科技正以其引领AI虚拟人软件创新的地位，不断推动着数字化时代的发展和创新。未来，随着技术的不断进步和应用的扩大，羽迹科技将继续引领行业的发展趋势，为用户和企业带来更多令人惊叹的数字化体验，开创AI虚拟人软件的新纪元。
                    </div>
                </div>
                <a href="/index" class="btn">
                    了解更多
                    <img src="@/assets/imgs/index/arrow.png" alt />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
import newsData from "@/utils/newJson";
export default {
    components: {
        Header,
    },
    computed: {
        device() {
            return this.$store.state.app.device;
        },
    },
    metaInfo: {
        title: "虚拟形象与直播的元宇宙社交?-羽迹美形", // set a title
        meta: [
            {
                // set meta
                name: "keyWords",
                content: "虚拟形象与直播的元宇宙社交?,羽迹美形",
            },
            {
                // set meta
                name: "description",
                content:
                    "二次元文化随着Z世代消费力量的崛起，也逐渐突破小众圈层走进品牌营销的大众视野",
            },
        ],
    },
    data() {
        return {
            path: "newsInfo3",
            obj: {},
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        var index = this.$route.params.index;
        newsData.forEach((el, i) => {
            if (el.index == index) {
                this.obj = el;
            }
        });
    },
    methods: {
        goback() {
            this.$router.go(-1);
        },
    },
};
</script>


<style lang="scss" scoped>
.yuji-news {
    .news {
        min-width: 720px;

        .main {
            .tags {
                height: 40px;
                line-height: 40px;
                color: #999;
                border-bottom: 1px solid #eee;
                font-size: 14px;

                a {
                    color: #999;
                }
            }

            width: 720px;

            .back {
                height: 50px;
                line-height: 50px;
                position: relative;
                padding-left: 20px;
                cursor: pointer;
                border-bottom: 1px solid #eee;
                width: 720px;
                background: #fff;

                &::before {
                    position: absolute;
                    top: 50%;
                    left: 0;
                    content: "";
                    width: 6px;
                    height: 6px;
                    border-left: 2px solid #666;
                    border-bottom: 2px solid #666;
                    transform: rotate(45deg) translateY(-50%);
                }

                span {
                    color: #666;
                    font-size: 14px;
                }
            }

            .news-box {
                // padding: 100px 0;
                // display: flex;
                // justify-content: center;
                // background: pink;
                padding: 50px 0 100px;

                .title {
                    font-size: 28px;
                    font-weight: 600;
                }

                .time {
                    color: #999;
                }

                .start {
                    font-size: 16px;
                    margin: 20px 0;
                    text-indent: 30px;
                    line-height: 28px;
                }

                .banner {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;

                    img {
                        width: 100%;
                        max-width: 660px;
                        height: auto;
                    }
                }

                .list {
                    margin: 20px 0;

                    .list-t {
                        font-size: 18px;
                        font-weight: 600;
                        margin: 16px 0;
                    }

                    .list-text {
                        text-indent: 30px;
                        line-height: 28px;
                    }
                }

                .end {
                    text-indent: 30px;
                    margin-top: 50px;
                    line-height: 28px;
                }
            }
        }

        .btn {
            width: 219px;
            height: 61px;
            background: linear-gradient(129deg, #42f1c9 0%, #2bbda0 100%);
            margin: 0 auto 40px;
            border-radius: 31px;
            color: #fff;
            font-weight: 600;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            img {
                margin-left: 10px;
            }
        }
    }

    &-mobile {
        .news {
            min-width: 100%;

            &.padding-top {
                padding-top: 50px;
            }

            .main {
                width: 100%;

                .back {
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    cursor: pointer;
                    border-bottom: 1px solid #eee;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    background: #fff;

                    &::before {
                        position: absolute;
                        top: 48%;
                        left: 8px;
                        content: "";
                        width: 6px;
                        height: 6px;
                        border-left: 2px solid #666;
                        border-bottom: 2px solid #666;
                        transform: rotate(45deg) translateY(-50%);
                    }

                    span {
                        color: #666;
                        font-size: 14px;
                    }
                }

                .news-box {
                    // padding: 100px 0;
                    // display: flex;
                    // justify-content: center;
                    // background: pink;
                    padding: 50px 20px 100px;

                    .title {
                        font-size: 24px;
                        font-weight: 600;
                    }

                    .time {
                        color: #999;
                        font-size: 14px;
                    }

                    .start {
                        font-size: 16px;
                        margin: 20px 0;
                        text-indent: 30px;
                        line-height: 28px;
                    }

                    .banner {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;

                        img {
                            width: 100%;
                        }
                    }

                    .list {
                        margin: 20px 0;

                        .list-t {
                            font-size: 16px;
                            font-weight: 600;
                            margin: 16px 0;
                        }

                        .list-text {
                            text-indent: 30px;
                            line-height: 28px;
                            font-size: 14px;
                        }
                    }

                    .end {
                        text-indent: 30px;
                        margin-top: 50px;
                        line-height: 28px;
                        font-size: 14px;
                    }
                }
            }

            .btn {
                width: 160px;
                height: 40px;
                font-size: 14px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/newsInfo/newsInfo205.vue